import moment from 'moment'
import store from '../store'
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import axios from 'axios'
import appConstants from '@/constants/app.constants'
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import download from 'downloadjs';


export default {
    computed: mapState([
        'isLoading',
        'jwtToken',
        'currentUserSession',
        'origin',
    ]),
    data() {
        return {
            inactivityTimerID: null,
        }
    },
    methods: {
        toggleFullScreenSpinner: function (value) {
            store.commit('TOGGLE_FULLSCREEN_SPINNER', value);
        },
        copyText: function (text) {
            navigator.clipboard.writeText(text).then(() => {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    text: "Copied to clipboard: "+text,
                    showConfirmButton: false,
                    timer: 1500
                });
            }).catch((err) => {
                console.log(err);
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    text: "Failed to copy discount: "+text,
                    showConfirmButton: false,
                    timer: 1500
                });
            });
        },
        getFedexToken: function () {
            axios.get(appConstants.FEDEX_BASE_URL + '?op=get_fedex_token')
            .then(function (response) {
                store.commit('SET_FEDEX_TOKEN', response.data.access_token);
            }.bind(this));
        },
        redirectToPage: function(destination) {
            this.$router.push(destination);
        },
        startInactivityTimer: function() {
            this.clearInactivityTimer(); // Clear any existing timer
            this.inactivityTimerID = setTimeout(() => {
                this.forceLogout(); // Call the logout function after 1 hour
            }, appConstants.TIMEOUT_DURATION);
        },
        resetTimer: function () {
            this.startInactivityTimer(); // Reset the timer on any user activity
        },
        clearInactivityTimer: function() {
            if (this.inactivityTimerID) {
                clearTimeout(this.inactivityTimerID);
            }
        },
        validateAuthToken: function (isLogout) {
            this.toggleFullScreenSpinner(true);
            axios.get(appConstants.SITEURL+'/?rest_route=/simple-jwt-login/v1/auth/validate&JWT='+this.jwtToken)
            .then((response) => {
                if (isLogout && response.data) {
                    this.handleLogout();
                } else {
                    store.commit('SET_SESSION_USER_ID', response.data.data.user.ID);
                }
                
            }).catch((error) => {
                error.response.data.data.message == "Expired token";
                this.forceLogout();
            });
        },
        forceLogout: function () {
            let timerInterval;
            Swal.fire({
            title: "Session Expired",
            html: "Logging you out...",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading();
            },
            willClose: () => {
                clearInterval(timerInterval);
            }
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                    this.handleLogout(true);
                }
            });
        },
        handleLogout: function (isForced) {
            this.toggleFullScreenSpinner(true);
            if (isForced) {
                this.clearCacheAfterLogout();
                this.$router.push('/login'); // Redirect to login
            } else {
                switch (this.currentUserSession) {
                    case appConstants.LOGIN_TYPE.CUSTOMER:
                        this.clearCacheAfterLogout();
                        this.$router.push('/login'); // Redirect to login
                        break;
                    default:
                        axios.post(appConstants.SITEURL + '?rest_route=/simple-jwt-login/v1/auth/revoke&JWT=' + this.jwtToken + '&AUTH_KEY=' + appConstants.AUTH_KEY)
                        .then((response) => {
                            //console.log(response.data)
                            if (response.data.success) {
                                this.clearCacheAfterLogout();
                                this.$router.push('/login'); // Redirect to login
                            }
                        });
                        break;
                }
            }
            
        },
        logoutUser: function () {
            if (this.isMobile()) {
                store.commit('SET_SIDEBAR_TOGGLE', true);
            }
            Swal.fire({
                icon: 'info',
                title: "Logout?",
                customClass: {
                    confirmButton: 'bg-primary'
                },
                text: "Confirm this action",
                showCancelButton: true,
                confirmButtonText: "Logout",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.validateAuthToken(true);
                }
            });
        },
        clearCacheAfterLogout: function () {
            store.commit('SET_JWT_TOKEN', null);
            store.commit('SET_SESSION_TYPE', null);
            store.commit('SET_ORDER_LIST_STORAGE', []);
            store.commit('SET_CURRENT_SESSION_FIRSTNAME',null);
            store.commit('SET_CURRENT_SESSION_LASTNAME',null);
            store.commit('SET_SESSION_RAILS_DATA', null);
            store.commit('SET_SESSION_RAILS_ID', null);
            store.commit('SET_CURRENT_SESSION_FIRSTNAME', null);
            store.commit('SET_CURRENT_SESSION_LASTNAME', null);
            store.commit('SET_SESSION_USER_ID', null);
        },
        createJWTToken: async function () {
            if (!this.jwtToken) {
                try {
                let response = await axios.post(appConstants.SITEURL+'/?rest_route=/simple-jwt-login/v1/auth&email='+this.userNameOrEmail+'&password='+this.userPassword+'&AUTH_KEY='+appConstants.AUTH_KEY);
                return response.data.data.jwt;
                } catch (error) {
                console.log(error);
                this.toggleFullScreenSpinner(false);
                }
            } else {
                return this.jwtToken;
            }
        },
        convertStateAbbreviation: function(stateAbbreviation) {
            return appConstants.STATES[stateAbbreviation.toUpperCase()];
        },
        getLatLangPerCountry: function (country) {
            const countries = {
            "AF": { name: "Afghanistan", coordinates: [ 65.7415, 29.5486 ] },
            "AL": { name: "Albania", coordinates: [ 20.1683, 41.1533 ] },
            "DZ": { name: "Algeria", coordinates: [ 1.6596, 28.0339 ] },
            "AS": { name: "American Samoa", coordinates: [ -170.1326, -14.2704 ] },
            "AD": { name: "Andorra", coordinates: [ 1.5211, 42.5462 ] },
            "AO": { name: "Angola", coordinates: [ 17.8739, -11.2027 ] },
            "AI": { name: "Anguilla", coordinates: [ -63.0686, 18.2206 ] },
            "AQ": { name: "Antarctica", coordinates: [ 0.0, -90.0 ] },
            "AG": { name: "Antigua and Barbuda", coordinates: [ -61.7964, 17.0608 ] },
            "AR": { name: "Argentina", coordinates: [ -63.6167, -38.4161 ] },
            "AM": { name: "Armenia", coordinates: [ 40.0692, 40.0692 ] },
            "AW": { name: "Aruba", coordinates: [ -69.9683, 12.5211 ] },
            "AU": { name: "Australia", coordinates: [ 133.7751, -25.2744 ] },
            "AT": { name: "Austria", coordinates: [ 13.3333, 47.3333 ] },
            "AZ": { name: "Azerbaijan", coordinates: [ 47.9266, 40.1431 ] },
            "BS": { name: "Bahamas", coordinates: [ -77.3963, 25.0343 ] },
            "BH": { name: "Bahrain", coordinates: [ 50.5577, 25.9304 ] },
            "BD": { name: "Bangladesh", coordinates: [ 90.3563, 23.685 ] },
            "BB": { name: "Barbados", coordinates: [ -59.5432, 13.1939 ] },
            "BY": { name: "Belarus", coordinates: [ 27.9534, 53.7098 ] },
            "BE": { name: "Belgium", coordinates: [ 4.4699, 50.8503 ] },
            "BZ": { name: "Belize", coordinates: [ -88.4976, 17.1899 ] },
            "BJ": { name: "Benin", coordinates: [ 2.3158, 9.3084 ] },
            "BM": { name: "Bermuda", coordinates: [ -64.7505, 32.3078 ] },
            "BT": { name: "Bhutan", coordinates: [ 90.4336, 27.5142 ] },
            "BO": { name: "Bolivia", coordinates: [ -64.6399, -16.5000 ] },
            "BA": { name: "Bosnia and Herzegovina", coordinates: [ 17.6791, 43.9159 ] },
            "BW": { name: "Botswana", coordinates: [ 24.6849, -22.3285 ] },
            "BR": { name: "Brazil", coordinates: [ -51.9253, -14.2350 ] },
            "IO": { name: "British Indian Ocean Territory", coordinates: [ 71.6788, -6.3432 ] },
            "VG": { name: "British Virgin Islands", coordinates: [ -64.6211, 18.4207 ] },
            "BN": { name: "Brunei", coordinates: [ 114.7277, 4.5353 ] },
            "BG": { name: "Bulgaria", coordinates: [ 25.4858, 42.7339 ] },
            "BF": { name: "Burkina Faso", coordinates: [ -1.5616, 12.2383 ] },
            "BI": { name: "Burundi", coordinates: [ 29.9189, -3.3731 ] },
            "KH": { name: "Cambodia", coordinates: [ 104.9909, 12.5657 ] },
            "CM": { name: "Cameroon", coordinates: [ 12.3547, 7.3697 ] },
            "CA": { name: "Canada", coordinates: [ -106.3468, 56.1304 ] },
            "CV": { name: "Cape Verde", coordinates: [ -23.605, 16.5388 ] },
            "KY": { name: "Cayman Islands", coordinates: [ -81.2546, 19.3133 ] },
            "CF": { name: "Central African Republic", coordinates: [ 20.9394, 6.6111 ] },
            "TD": { name: "Chad", coordinates: [ 14.3733, 15.4542 ] },
            "CL": { name: "Chile", coordinates: [ -71.545, -35.6751 ] },
            "CN": { name: "China", coordinates: [ 104.1954, 35.8617 ] },
            "CX": { name: "Christmas Island", coordinates: [ 105.689, -10.4475 ] },
            "CC": { name: "Cocos (Keeling) Islands", coordinates: [ 96.8709, -12.1646 ] },
            "CO": { name: "Colombia", coordinates: [ -74.2973, 4.5709 ] },
            "KM": { name: "Comoros", coordinates: [ 43.3333, -11.6667 ] },
            "CG": { name: "Congo - Brazzaville", coordinates: [ 15.8277, -0.2280 ] },
            "CD": { name: "Congo - Kinshasa", coordinates: [ 15.0000, -4.0000 ] },
            "CK": { name: "Cook Islands", coordinates: [ -159.7777, -21.2368 ] },
            "CR": { name: "Costa Rica", coordinates: [ -83.7534, 9.7489 ] },
            "CI": { name: "Côte d'Ivoire", coordinates: [ -5.5471, 7.5399 ] },
            "HR": { name: "Croatia", coordinates: [ 15.2, 45.1 ] },
            "CU": { name: "Cuba", coordinates: [ -77.7812, 21.5216 ] },
            "CW": { name: "Curaçao", coordinates: [ -69.0689, 12.1696 ] },
            "CY": { name: "Cyprus", coordinates: [ 33.2232, 35.1264 ] },
            "CZ": { name: "Czechia", coordinates: [ 15.4729, 49.8175 ] },
            "DK": { name: "Denmark", coordinates: [ 9.5018, 56.2639 ] },
            "DJ": { name: "Djibouti", coordinates: [ 43.1426, 11.8251 ] },
            "DM": { name: "Dominica", coordinates: [ -61.3710, 15.4140 ] },
            "DO": { name: "Dominican Republic", coordinates: [ -70.1627, 18.7357 ] },
            "EC": { name: "Ecuador", coordinates: [ -78.1834, -1.8312 ] },
            "EG": { name: "Egypt", coordinates: [ 31.2357, 30.0444 ] },
            "SV": { name: "El Salvador", coordinates: [ -88.8965, 13.7942 ] },
            "GQ": { name: "Equatorial Guinea", coordinates: [ 10.2679, 1.6500 ] },
            "ER": { name: "Eritrea", coordinates: [ 39.7823, 15.1794 ] },
            "EE": { name: "Estonia", coordinates: [ 25.0136, 58.5953 ] },
            "ET": { name: "Ethiopia", coordinates: [ 39.7272, 9.145 ] },
            "FK": { name: "Falkland Islands", coordinates: [ -59.0087, -51.6960 ] },
            "FO": { name: "Faroe Islands", coordinates: [ -6.9118, 61.8926 ] },
            "FJ": { name: "Fiji", coordinates: [ 178.0650, -17.7134 ] },
            "FI": { name: "Finland", coordinates: [ 25.7482, 61.9241 ] },
            "FR": { name: "France", coordinates: [ 2.2137, 46.6034 ] },
            "GF": { name: "French Guiana", coordinates: [ -53.1258, 3.9339 ] },
            "PF": { name: "French Polynesia", coordinates: [ -149.4068, -17.6797 ] },
            "GA": { name: "Gabon", coordinates: [ 11.6094, -0.8037 ] },
            "GM": { name: "Gambia", coordinates: [ -15.3101, 13.4432 ] },
            "GE": { name: "Georgia", coordinates: [ 42.3154, 42.3154 ] },
            "DE": { name: "Germany", coordinates: [ 10.4515, 51.1657 ] },
            "GH": { name: "Ghana", coordinates: [ -0.2060, 7.5469 ] },
            "GI": { name: "Gibraltar", coordinates: [ -5.3454, 36.1408 ] },
            "GR": { name: "Greece", coordinates: [ 21.8243, 39.0742 ] },
            "GL": { name: "Greenland", coordinates: [ -42.6043, 71.7069 ] },
            "GD": { name: "Grenada", coordinates: [ -61.6042, 12.1165 ] },
            "GP": { name: "Guadeloupe", coordinates: [ -61.5820, 16.9950 ] },
            "GU": { name: "Guam", coordinates: [ 144.7841, 13.4443 ] },
            "GT": { name: "Guatemala", coordinates: [ -90.2308, 15.7835 ] },
            "GG": { name: "Guernsey", coordinates: [ -2.5895, 49.4657 ] },
            "GN": { name: "Guinea", coordinates: [ -10.7085, 9.9456 ] },
            "GW": { name: "Guinea-Bissau", coordinates: [ -15.1804, 11.8037 ] },
            "GY": { name: "Guyana", coordinates: [ -58.9302, 4.8604 ] },
            "HT": { name: "Haiti", coordinates: [ -72.2852, 18.9712 ] },
            "HM": { name: "Heard Island and McDonald Islands", coordinates: [ 73.5000, -53.1000 ] },
            "HN": { name: "Honduras", coordinates: [ -86.2419, 13.7942 ] },
            "HK": { name: "Hong Kong", coordinates: [ 114.1095, 22.3964 ] },
            "HU": { name: "Hungary", coordinates: [ 19.5033, 47.1625 ] },
            "IS": { name: "Iceland", coordinates: [ -19.0208, 64.9631 ] },
            "IN": { name: "India", coordinates: [ 78.9629, 20.5937 ] },
            "ID": { name: "Indonesia", coordinates: [ 113.9213, -0.7893 ] },
            "IR": { name: "Iran", coordinates: [ 53.6880, 32.4279 ] },
            "IQ": { name: "Iraq", coordinates: [ 43.6793, 33.2232 ] },
            "IE": { name: "Ireland", coordinates: [ -8.2439, 53.4129 ] },
            "IM": { name: "Isle of Man", coordinates: [ -4.4818, 54.2361 ] },
            "IL": { name: "Israel", coordinates: [ 34.8516, 31.0461 ] },
            "IT": { name: "Italy", coordinates: [ 12.5674, 41.8719 ] },
            "JE": { name: "Jersey", coordinates: [ -2.1313, 49.2144 ] },
            "JO": { name: "Jordan", coordinates: [ 36.2384, 30.5852 ] },
            "KZ": { name: "Kazakhstan", coordinates: [ 66.9237, 48.0196 ] },
            "KE": { name: "Kenya", coordinates: [ 37.9062, -0.0236 ] },
            "KI": { name: "Kiribati", coordinates: [ -157.3583, -3.3704 ] },
            "KR": { name: "Korea South", coordinates: [ 127.7669, 35.9078 ] },
            "KW": { name: "Kuwait", coordinates: [ 47.4818, 29.3117 ] },
            "KG": { name: "Kyrgyzstan", coordinates: [ 74.7661, 41.2044 ] },
            "LA": { name: "Laos", coordinates: [ 102.4955, 19.8563 ] },
            "LV": { name: "Latvia", coordinates: [ 24.6032, 56.8796 ] },
            "LB": { name: "Lebanon", coordinates: [ 35.8623, 33.8547 ] },
            "LS": { name: "Lesotho", coordinates: [ 28.2336, -29.6099 ] },
            "LR": { name: "Liberia", coordinates: [ -9.4295, 6.4281 ] },
            "LY": { name: "Libya", coordinates: [ 17.2283, 26.3351 ] },
            "LI": { name: "Liechtenstein", coordinates: [ 9.5215, 47.1660 ] },
            "LT": { name: "Lithuania", coordinates: [ 23.8813, 55.1694 ] },
            "LU": { name: "Luxembourg", coordinates: [ 6.1296, 49.8153 ] },
            "MO": { name: "Macau", coordinates: [ 113.5439, 22.1987 ] },
            "MK": { name: "North Macedonia", coordinates: [ 21.7453, 41.6086 ] },
            "MG": { name: "Madagascar", coordinates: [ 46.8691, -18.7669 ] },
            "MW": { name: "Malawi", coordinates: [ 34.3015, -13.2543 ] },
            "MY": { name: "Malaysia", coordinates: [ 101.9758, 4.2105 ] },
            "MV": { name: "Maldives", coordinates: [ 73.2207, 3.2028 ] },
            "ML": { name: "Mali", coordinates: [ -3.9962, 17.5707 ] },
            "MT": { name: "Malta", coordinates: [ 14.3754, 35.9375 ] },
            "MH": { name: "Marshall Islands", coordinates: [ 168.0500, 7.1315 ] },
            "MR": { name: "Mauritania", coordinates: [ -10.9408, 21.0074 ] },
            "MU": { name: "Mauritius", coordinates: [ 63.3731, -20.3484 ] },
            "YT": { name: "Mayotte", coordinates: [ 45.1662, -12.8275 ] },
            "MX": { name: "Mexico", coordinates: [ -102.5528, 23.6345 ] },
            "FM": { name: "Micronesia", coordinates: [ 162.1151, 7.4251 ] },
            "MD": { name: "Moldova", coordinates: [ 28.6333, 47.4116 ] },
            "MC": { name: "Monaco", coordinates: [ 7.4394, 43.7333 ] },
            "MN": { name: "Mongolia", coordinates: [ 105.0000, 46.0000 ] },
            "ME": { name: "Montenegro", coordinates: [ 19.3744, 42.7087 ] },
            "MS": { name: "Montserrat", coordinates: [ -62.1874, 16.7417 ] },
            "MA": { name: "Morocco", coordinates: [ -7.0926, 31.7917 ] },
            "MZ": { name: "Mozambique", coordinates: [ 35.5296, -18.6657 ] },
            "MM": { name: "Myanmar (Burma)", coordinates: [ 96.1996, 21.9134 ] },
            "NA": { name: "Namibia", coordinates: [ 18.4904, -22.5597 ] },
            "NR": { name: "Nauru", coordinates: [ 166.9315, -0.5228 ] },
            "NP": { name: "Nepal", coordinates: [ 80.2707, 28.3949 ] },
            "NL": { name: "Netherlands", coordinates: [ 5.2913, 52.1326 ] },
            "NC": { name: "New Caledonia", coordinates: [ 165.6180, -22.4296 ] },
            "NZ": { name: "New Zealand", coordinates: [ 174.8859, -40.9006 ] },
            "NI": { name: "Nicaragua", coordinates: [ -85.2072, 12.8654 ] },
            "NE": { name: "Niger", coordinates: [ 8.0817, 17.6078 ] },
            "NG": { name: "Nigeria", coordinates: [ 8.6753, 9.0820 ] },
            "NU": { name: "Niue", coordinates: [ -169.8688, -19.0544 ] },
            "NF": { name: "Norfolk Island", coordinates: [ 167.9547, -29.0408 ] },
            "MP": { name: "Northern Mariana Islands", coordinates: [ 145.7500, 14.5500 ] },
            "NO": { name: "Norway", coordinates: [ 8.4689, 60.4720 ] },
            "OM": { name: "Oman", coordinates: [ 55.9233, 21.5126 ] },
            "PK": { name: "Pakistan", coordinates: [ 69.3451, 30.3753 ] },
            "PW": { name: "Palau", coordinates: [ 134.5825, 7.5149 ] },
            "PS": { name: "Palestine", coordinates: [ 35.3028, 31.9474 ] },
            "PA": { name: "Panama", coordinates: [ -80.7821, 8.9824 ] },
            "PG": { name: "Papua New Guinea", coordinates: [ 143.9556, -6.3149 ] },
            "PY": { name: "Paraguay", coordinates: [ -58.4438, -23.4420 ] },
            "PE": { name: "Peru", coordinates: [ -75.0152, -9.1900 ] },
            "PH": { name: "Philippines", coordinates: [ 121.7740, 12.8797 ] },
            "PN": { name: "Pitcairn Islands", coordinates: [ -130.1016, -24.7036 ] },
            "PL": { name: "Poland", coordinates: [ 19.1451, 51.9194 ] },
            "PT": { name: "Portugal", coordinates: [ -8.2245, 39.3999 ] },
            "PR": { name: "Puerto Rico", coordinates: [ -66.5901, 18.2208 ] },
            "QA": { name: "Qatar", coordinates: [ 51.1833, 25.2761 ] },
            "RE": { name: "Réunion", coordinates: [ 55.5364, -21.1151 ] },
            "RO": { name: "Romania", coordinates: [ 24.9668, 45.9432 ] },
            "RU": { name: "Russia", coordinates: [ 105.3188, 61.5240 ] },
            "RW": { name: "Rwanda", coordinates: [ 29.8739, -1.9403 ] },
            "SH": { name: "Saint Helena", coordinates: [ -5.7074, -15.9653 ] },
            "KN": { name: "Saint Kitts and Nevis", coordinates: [ -62.7820, 17.3578 ] },
            "LC": { name: "Saint Lucia", coordinates: [ -60.9789, 13.9094 ] },
            "PM": { name: "Saint Pierre and Miquelon", coordinates: [ -56.3159, 46.8256 ] },
            "VC": { name: "Saint Vincent and the Grenadines", coordinates: [ -61.2872, 12.9843 ] },
            "WS": { name: "Samoa", coordinates: [ -172.1046, -13.7590 ] },
            "SM": { name: "San Marino", coordinates: [ 12.4578, 43.9333 ] },
            "ST": { name: "Sao Tome and Principe", coordinates: [ 6.6131, 0.1864 ] },
            "SA": { name: "Saudi Arabia", coordinates: [ 45.0792, 23.8859 ] },
            "SN": { name: "Senegal", coordinates: [ -14.4524, 14.6928 ] },
            "RS": { name: "Serbia", coordinates: [ 21.0059, 44.0165 ] },
            "SC": { name: "Seychelles", coordinates: [ 56.2474, -4.6796 ] },
            "SL": { name: "Sierra Leone", coordinates: [ -11.7799, 8.4606 ] },
            "SG": { name: "Singapore", coordinates: [ 103.8198, 1.3521 ] },
            "SX": { name: "Sint Maarten", coordinates: [ -63.0558, 18.0428 ] },
            "SK": { name: "Slovakia", coordinates: [ 19.7038, 48.6690 ] },
            "SI": { name: "Slovenia", coordinates: [ 14.9955, 46.1512 ] },
            "SB": { name: "Solomon Islands", coordinates: [ 160.0000, -9.0000 ] },
            "SO": { name: "Somalia", coordinates: [ 46.1996, 5.1521 ] },
            "ZA": { name: "South Africa", coordinates: [ 22.9375, -30.5595 ] },
            "SS": { name: "South Sudan", coordinates: [ 29.8236, 6.8769 ] },
            "ES": { name: "Spain", coordinates: [ -3.7038, 40.4168 ] },
            "LK": { name: "Sri Lanka", coordinates: [ 80.7718, 7.8731 ] },
            "SD": { name: "Sudan", coordinates: [ 30.2176, 12.8628 ] },
            "SR": { name: "Suriname", coordinates: [ -56.0278, 3.9193 ] },
            "SZ": { name: "Eswatini", coordinates: [ 31.4659, -26.5225 ] },
            "SE": { name: "Sweden", coordinates: [ 18.6435, 60.1282 ] },
            "CH": { name: "Switzerland", coordinates: [ 8.2275, 46.8182 ] },
            "SY": { name: "Syria", coordinates: [ 38.9968, 34.8021 ] },
            "TW": { name: "Taiwan", coordinates: [ 121.5654, 25.0375 ] },
            "TJ": { name: "Tajikistan", coordinates: [ 71.2761, 38.8610 ] },
            "TZ": { name: "Tanzania", coordinates: [ 34.8888, -6.3690 ] },
            "TH": { name: "Thailand", coordinates: [ 100.9925, 15.8700 ] },
            "TL": { name: "Timor-Leste", coordinates: [ 125.8417, -8.8742 ] },
            "TG": { name: "Togo", coordinates: [ 0.8248, 8.6195 ] },
            "TK": { name: "Tokelau", coordinates: [ -171.8570, -9.2005 ] },
            "TO": { name: "Tonga", coordinates: [ -175.1982, -21.1788 ] },
            "TT": { name: "Trinidad and Tobago", coordinates: [ -61.2225, 10.6918 ] },
            "TN": { name: "Tunisia", coordinates: [ 9.5375, 33.8869 ] },
            "TR": { name: "Turkey", coordinates: [ 35.2433, 38.9637 ] },
            "TM": { name: "Turkmenistan", coordinates: [ 59.5563, 38.9697 ] },
            "TC": { name: "Turks and Caicos Islands", coordinates: [ -71.7979, 21.7664 ] },
            "TV": { name: "Tuvalu", coordinates: [ 179.1945, -7.1095 ] },
            "UG": { name: "Uganda", coordinates: [ 32.2903, 1.3733 ] },
            "UA": { name: "Ukraine", coordinates: [ 31.1656, 48.3794 ] },
            "AE": { name: "United Arab Emirates", coordinates: [ 53.8478, 23.4241 ] },
            "GB": { name: "United Kingdom", coordinates: [ -0.1276, 51.5074 ] },
            "US": { name: "United States", coordinates: [ -95.7129, 37.0902 ] },
            "UY": { name: "Uruguay", coordinates: [ -55.7652, -32.5228 ] },
            "UZ": { name: "Uzbekistan", coordinates: [ 64.5853, 41.3775 ] },
            "VU": { name: "Vanuatu", coordinates: [ 166.9592, -15.3764 ] },
            "VA": { name: "Vatican City", coordinates: [ 12.4534, 41.9029 ] },
            "VE": { name: "Venezuela", coordinates: [ -66.5897, 6.4238 ] },
            "VN": { name: "Vietnam", coordinates: [ 108.2772, 14.0583 ] },
            "WF": { name: "Wallis and Futuna", coordinates: [ -176.2000, -13.3000 ] },
            "EH": { name: "Western Sahara", coordinates: [ -12.8850, 24.2159 ] },
            "YE": { name: "Yemen", coordinates: [ 15.5524, 48.5164 ] },
            "ZM": { name: "Zambia", coordinates: [ 27.8493, -13.1339 ] },
            "ZW": { name: "Zimbabwe", coordinates: [ 29.1549, -19.0154 ] }
            };
            return countries[country];
        },
        getLatLangPerRegion: function (region) {
            switch (region) {
                case 'AK':
                    return ['63.588753', '-154.493062'];
                case 'AL':
                    return ['32.318231', '-86.902298'];
                case 'AR':
                    return ['35.20105', '-91.831833'];
                case 'AZ':
                    return ['34.048928', '-111.093731'];
                case 'CA':
                    return ['36.778261', '-119.417932'];
                case 'CO':
                    return ['39.550051', '-105.782067'];
                case 'CT':
                    return ['41.603221', '-73.087749'];
                case 'DC':
                    return ['38.905985', '-77.033418'];
                case 'DE':
                    return ['38.910832', '-75.52767'];
                case 'FL':
                    return ['27.664827', '-81.515754'];
                case 'GA':
                    return ['32.157435', '-82.907123'];
                case 'HI':
                    return ['19.898682', '-155.665857'];
                case 'IA':
                    return ['41.878003', '-93.097702'];
                case 'ID':
                    return ['44.068202', '-114.742041'];
                case 'IL':
                    return ['40.633125', '-89.398528'];
                case 'IN':
                    return ['40.551217', '-85.602364'];
                case 'KS':
                    return ['39.011902', '-98.484246'];
                case 'KY':
                    return ['37.839333', '-84.270018'];
                case 'LA':
                    return ['31.244823', '-92.145024'];
                case 'MA':
                    return ['42.407211', '-71.382437'];
                case 'MD':
                    return ['39.045755', '-76.641271'];
                case 'ME':
                    return ['45.253783', '-69.445469'];
                case 'MI':
                    return ['44.314844', '-85.602364'];
                case 'MN':
                    return ['46.729553', '-94.6859'];
                case 'MO':
                    return ['37.964253', '-91.831833'];
                case 'MS':
                    return ['32.354668', '-89.398528'];
                case 'MT':
                    return ['46.879682', '-110.362566'];
                case 'NC':
                    return ['35.759573', '-79.0193'];
                case 'ND':
                    return ['47.551493', '-101.002012'];
                case 'NE':
                    return ['41.492537', '-99.901813'];
                case 'NH':
                    return ['43.193852', '-71.572395'];
                case 'NJ':
                    return ['40.058324', '-74.405661'];
                case 'NM':
                    return ['34.97273', '-105.032363'];
                case 'NV':
                    return ['38.80261', '-116.419389'];
                case 'NY':
                    return ['43.299428', '-74.217933'];
                case 'OH':
                    return ['40.417287', '-82.907123'];
                case 'OK':
                    return ['35.007752', '-97.092877'];
                case 'OR':
                    return ['43.804133', '-120.554201'];
                case 'PA':
                    return ['41.203322', '-77.194525'];
                case 'PR':
                    return ['18.220833', '-66.590149'];
                case 'RI':
                    return ['41.580095', '-71.477429'];
                case 'SC':
                    return ['33.836081', '-81.163725'];
                case 'SD':
                    return ['43.969515', '-99.901813'];
                case 'TN':
                    return ['35.517491', '-86.580447'];
                case 'TX':
                    return ['31.968599', '-99.901813'];
                case 'UT':
                    return ['39.32098', '-111.093731'];
                case 'VA':
                    return ['37.431573', '-78.656894'];
                case 'VT':
                    return ['44.558803', '-72.577841'];
                case 'WA':
                    return ['47.751074', '-120.740139'];
                case 'WI':
                    return ['43.78444', '-88.787868'];
                case 'WV':
                    return ['38.597626', '-80.454903'];
                case 'WY':
                    return ['42.755966', '-107.302490'];
                default:
                    console.log(region);
                    return ['0', '0'];
            }
        },
        getRailsApplicationData: function () {
            axios.get(appConstants.SERVICESURL+'/api/v1/resellers?business_email='+this.currentSessionEmail)
            .then((response) => {
                console.log(response.data);
                if (response.data.total_count) {
                    store.commit('SET_SESSION_RAILS_ID', response.data.resellers[0].id);
                    store.commit('SET_SESSION_RAILS_DATA', response.data.resellers[0]);
                    store.commit('SET_CURRENT_SESSION_FIRSTNAME', response.data.resellers[0].firstname);
                    store.commit('SET_CURRENT_SESSION_LASTNAME', response.data.resellers[0].lastname);
                }
            });
        },
        cleanString: function (string) {
            if (string) {
                return string.replace(/&amp;/g, '&');
            } else {
                return null;
            }
        },
        round: function (num, decimalPlaces = 0) {
            num = Math.round(num + "e" + decimalPlaces);
            return Number(num + "e" + -decimalPlaces);
        },
        cleanVinNumber: function (vin) {
            return vin.replace(/I/gi, '1').replace(/O/gi, '0').replace(/Q/gi, '0');
        },
        formatRegularPrice(price) {
            var finalPrice = null;
            if (!price.includes('.')) {
                finalPrice = price + '.00';
            } else {
                if (price.split('.')[1].length == 1) {
                    finalPrice = price + '0';
                } else {
                    finalPrice = price;
                }
            }
            return finalPrice;
        },
        validateEmail: function (email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        deviceType: function () {
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        },
        isMobile: function () {
            if (this.deviceType == 'mobile' || this.deviceType == 'tablet') {
                return true;
            } else {
                return false;
            }
        },
        formatDate: function (date) {
            return moment(date).fromNow();
        },
        validateVin: function (vin) {
            if (vin == "11111111111111111") { return false; }
            if (!vin.match("^([0-9a-hj-npr-zA-HJ-NPR-Z]{10,17})+$")) { return false; }
            var letters = [{ k: "A", v: 1 }, { k: "B", v: 2 }, { k: "C", v: 3 },
            { k: "D", v: 4 }, { k: "E", v: 5 }, { k: "F", v: 6 }, { k: "G", v: 7 },
            { k: "H", v: 8 }, { k: "J", v: 1 }, { k: "K", v: 2 }, { k: "L", v: 3 },
            { k: "M", v: 4 }, { k: "N", v: 5 }, { k: "P", v: 7 }, { k: "R", v: 9 },
            { k: "S", v: 2 }, { k: "T", v: 3 }, { k: "U", v: 4 }, { k: "V", v: 5 },
            { k: "W", v: 6 }, { k: "X", v: 7 }, { k: "Y", v: 8 }, { k: "Z", v: 9 }];
            var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
            var exclude = ["I", "O", "Q"];
            var val = 0;
            for (var idx = 0; idx < vin.length; idx++) {
                var item = vin.charAt(idx).toUpperCase();
                if (exclude.includes(function (x) { return x == item; })) { return false; }
                var pos = (item.match("^[0-9]+$") != null) ? parseInt(item) : letters.filter(function (letter) { return letter.k == item; })[0].v;
                val += (pos * weights[idx]);
            }
            var checksum = (val % 11);
            //  if (!(vin.charAt(8) == (checksum < 10 ? checksum.toString() : "X"))) {
            //     return 'ninth-digit-error';
            // }
            return (vin.charAt(8) == (checksum < 10 ? checksum.toString() : "X"));
        },
        exportTableToCsv: function (tableId) {
            // Variable to store the final csv data
            let csv_data = [];

            // Get the table element by ID
            let table = document.getElementById(tableId);
            if (!table) {
                console.error("Table with specified ID not found");
                return;
            }

            // Get each row data
            let rows = table.getElementsByTagName('tr');
            for (let i = 0; i < rows.length; i++) {

                // Get each column data
                let cols = rows[i].querySelectorAll('td,th');

                // Stores each csv row data
                let csvrow = [];
                for (let j = 0; j < cols.length; j++) {

                    // Get the text data of each cell
                    // of a row and push it to csvrow
                    csvrow.push(cols[j].textContent.trim());
                }

                // Combine each column value with comma
                csv_data.push(csvrow.join(","));
            }

            // Combine each row data with new line character
            csv_data = csv_data.join('\n');

            // Call this function to download csv file  
            this.downloadCSVFile(csv_data, tableId);
        },
        downloadCSVFile: function (csv_data, tableId) {

            // Create CSV file object and feed
            // our csv_data into it
            let CSVFile = new Blob([csv_data], {
                type: "text/csv"
            });

            // Create to temporary link to initiate
            // download process
            let temp_link = document.createElement('a');

            // Download csv file
            temp_link.download = tableId + '-' + this.dateFrom + '-to-' + this.dateTo + ".csv";
            let url = window.URL.createObjectURL(CSVFile);
            temp_link.href = url;

            // This link should not be displayed
            temp_link.style.display = "none";
            document.body.appendChild(temp_link);

            // Automatically click the link to
            // trigger download
            temp_link.click();
            document.body.removeChild(temp_link);
        },
        base64ToArrayBuffer: function (base64) {
            const binaryString = window.atob(base64); // Decode base64 to binary string
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        },
        printReturnShippingLabel: function (orderDetails, shipmentDetails) {
            this.toggleFullScreenSpinner(true);
            // let generatedBody = JSON.parse('
            //     {"carrierCode": "'+appConstants.STAMPS_COM_CARRIER_CODE+'",
            //     "serviceCode": "'+appConstants.STAMPS_COM_SERVICE_CODE+'",
            //     "packageCode": "package",
            //     "confirmation": "delivery",
            //     "shipDate": "'+moment().format('YYYY-MM-DD')+'",
            //     "weight":'+JSON.stringify(shipmentDetails.weight)+',
            //     "dimensions": '+JSON.stringify(shipmentDetails.dimensions)+',
            //     "shipFrom":
            //     {"name": "'+orderDetails.shipping.first_name+' '+orderDetails.shipping.last_name+'",
            //         "company": null,
            //         "street1":"'+orderDetails.shipping.address_1+'",
            //         "street2": null,
            //         "street3": null,
            //         "city": "'+orderDetails.shipping.city+'",
            //         "state": "'+orderDetails.shipping.state+'",
            //         "postalCode": "'+orderDetails.shipping.postcode+'",
            //         "country": "US",
            //         "phone": "'+(orderDetails.shipping.phone ? orderDetails.shipping.phone : orderDetails.billing.phone)+'",
            //         "residential": false},
            //         "shipTo": {"name": "MAKS Enterprises LLC",
            //             "company": "MAK\'s TIPM Rebuilders",
            //             "street1": "9531 Cozycroft Ave",
            //             "street2": null,
            //             "street3": null,
            //             "city": "Chatsworth",
            //             "state": "CA",
            //             "postalCode": "91311",
            //             "country": "US",
            //             "phone": "+1 818-651-9325",
            //             "residential": false},
            //             "insuranceOptions": null,"internationalOptions": null,"advancedOptions": null,"testLabel": false}');
            let generatedBody =  {
				"carrierCode": appConstants.STAMPS_COM_CARRIER_CODE,
				"serviceCode": appConstants.STAMPS_COM_SERVICE_CODE,
				"packageCode": "package",
				"confirmation": "delivery",
				"shipDate": moment().format('YYYY-MM-DD'),
				"weight": shipmentDetails.weight,
				"dimensions": shipmentDetails.dimensions,
				"shipFrom": {
					"name": orderDetails.shipping.first_name+' '+orderDetails.shipping.last_name,
					"company": (orderDetails.shipping.company ? orderDetails.shipping.company : orderDetails.billing.company),
					"street1": orderDetails.shipping.address_1.replace(/,/g,''),
					"street2": null,
					"street3": null,
					"city": orderDetails.shipping.city,
					"state": orderDetails.shipping.state,
					"postalCode": orderDetails.shipping.postcode,
					"country": "US",
					"phone": (orderDetails.shipping.phone ? orderDetails.shipping.phone : orderDetails.billing.phone),
					"residential": false
				},
				"shipTo": {
					"name": "ECM Rebuilders",
					"company": "MAKS ECM Rebuilders",
					"street1": "9531 Cozycroft Ave",
					"street2": null,
					"street3": null,
					"city": "Chatsworth",
					"state": "CA",
					"postalCode": "91311",
					"country": "US",
					"phone": "+1 818-798-5558",
					"residential": false
				},
				"insuranceOptions": null,
				"internationalOptions": null,
				"advancedOptions": null,
				"testLabel": false
			};
            // let bodyFormData = new FormData();
            // bodyFormData.append('bodyData', JSON.stringify(generatedBody));
              
              axios({
                method: "post",
                url: appConstants.SHIPSTATION_BASE_URL+'shipments/createlabel',
                data: generatedBody,
                headers: { "Content-Type": "application/json", "Authorization": appConstants.SHIPSTATION_AUTH },
              }).then(function (response) {
                if (response.data) {
                    this.toggleFullScreenSpinner(false);
                    this.downloadPDF(response.data.labelData, this.selectedOrderNumber);
                }
              }.bind(this)).catch( function () {
                this.toggleFullScreenSpinner(false);
                var errorMessage = '';
                var phone = orderDetails.shipping.phone ? orderDetails.shipping.phone : orderDetails.billing.phone;
                if (!phone) {
                  errorMessage = 'This feature is only available to customers who provided their phone number during checkout'
                } else {
                  errorMessage = 'This feature is only available to customers inside the United States'
                }
                Swal.fire({
                  customClass: {
                    confirmButton: 'bg-primary'
                  },
                  icon: 'error',
                  title: 'Sorry!',
                  html: errorMessage,
                });
              }.bind(this));
          },
        // downloadPDF: function (pdf, orderNumber) {
        //     const linkSource = `data:application/pdf;base64,${pdf}`;
        //     const downloadLink = document.createElement("a");
        //     const fileName = orderNumber.toString()+".pdf";
        //     downloadLink.href = linkSource;
        //     downloadLink.download = fileName;
        //     downloadLink.click();
        // },
        downloadPDF: async function (base64Pdf, ordernumber) {
            // Convert Base64 to ArrayBuffer
            const existingPdfBytes = this.base64ToArrayBuffer(base64Pdf);
        
            // Load a PDFDocument from the existing PDF bytes
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
        
            // Embed the Helvetica font
            const helveticaFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
        
            // Get the first page of the document
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
        
            // Get the width and height of the first page
            const { width } = firstPage.getSize();
            const newOrderNumber = ordernumber;
            const textWidth = helveticaFont.widthOfTextAtSize(newOrderNumber, 15);
        
            // Draw a string of text centered at the very bottom with margin
            firstPage.drawText(newOrderNumber, {
                x: (width - textWidth) / 2,  // Center horizontally
                y: 5,             // Set margin from the bottom
                size: 15,
                font: helveticaFont,
                color: rgb(0, 0, 0),  // Green color
            });
        
            // Serialize the PDFDocument to bytes (a Uint8Array)
            const pdfBytes = await pdfDoc.save();
        
            // Trigger the browser to download the PDF document
            download(pdfBytes, newOrderNumber+".pdf", "application/pdf");
        },
        sendSlackNotification: async function (order_number, vin, sku) {
            var bodyFormData = new FormData();
            var jsonString = `{"blocks":[{"type":"section","text":{"type":"mrkdwn","text":"`+appConstants.NOTE_TEXT+` for ` + (appConstants.SITEURL.includes('tipm') ? 'TIPM' : 'ECM') + ` Order *#` + order_number + `* via ` + (this.origin ? this.origin.toUpperCase() : 'Customer Portal') + `"}},{"type":"section","text":{"type":"mrkdwn","text":"VIN: ` + vin + ` \\n SKU: ` + sku + `"}}]}`;
            bodyFormData.append('bodyData', jsonString);
            axios({
                method: "post",
                url: 'https://database.tipmrebuilders.com/shipstation/slack.php?op=send-slack-notification',
                data: bodyFormData,
                headers: { "Content-Type": "multipart/form-data" },
            }).then((response) => {
                if (response.data) {
                    return response.data
                }
            });
            return order_number+'-'+vin+'-'+sku;
        },
        submitToDatabase: async function (trackerData) {
            console.log(trackerData);
            let response = await axios({
                method: "POST",
                url: appConstants.SERVICESURL + '/api/v1/vin_trackers',
                data: trackerData,
                headers: { "Content-Type": "multipart/form-data" },
            })
            return response.data.vin_tracker.vin;
        },
        submitToWoocommerce: async function (orderNotes, order_id) {
            var bodyFormData = new FormData();
            bodyFormData.append("note", orderNotes.toString());
            let response = await axios({
                method: "POST",
                url: appConstants.SITEURL + '/wp-json/wc/v3/orders/' + order_id + '/notes/',
                data: bodyFormData,
                headers: { 'Authorization': appConstants.SITEAUTH }
            })
            return response.data;
        },
        updateWooCommerceOrder: async function (order_id, vin) {
            var bodyFormData = new FormData();
            bodyFormData.append("vin", vin);
            let response = await axios({
                method: "POST",
                url: appConstants.SITEURL + '/wp-json/custom-api/v1/update-order-vin/' + order_id,
                data: bodyFormData,
                headers: { 'Authorization': appConstants.SITEAUTH }
            })
            return response.data;
        },
        submitToShipstation: async function (order_number, vin, sku) {
            axios.get(appConstants.SHIPSTATION_BASE_URL + 'search_order_by_number&order_number=' + order_number)
                .then(function (response) {
                    if (response.data.total) {
                        var order = response.data.orders[0];
                        order.items.forEach(function (item) {
                            if (item.sku == sku) {
                                item.options.push({
                                    "name": "Provided VIN",
                                    "value": vin
                                });
                            }
                        });
                        var bodyFormData = new FormData();
                        bodyFormData.append('bodyData', JSON.stringify(order));
                        axios({
                            method: "POST",
                            url: appConstants.SHIPSTATION_BASE_URL + 'create_update_order',
                            data: bodyFormData
                        })
                            .then(function (response) {
                                if (response.data) {
                                    return response.data;
                                }
                            }.bind(this));
                    }
                }.bind(this));

        },
    }
};